import { Controller } from 'react-hook-form'

export default ({
  name,
  control,
  label,
  defaultValue = false,
  options = [],
  disabled = false,
  rules = {},
  validator = {},
  className = ""
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field }) => (
      <div className={`${className} space-y-4`}>
        <label className={`select w-full ${validator.hasError ? "validator" : ''}`}
               {...(validator.hasError && validator.hasError(name) ? {'aria-invalid': true} : {})}
        >
          <span className="label">{label}</span>
          <select
            {...field}
            value={field.value || ''}
            disabled={disabled}
          >
            <option value="" disabled>{defaultValue || "Sélectionnez une valeur"}</option>
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
        {validator.getErrorMessage && (
          <div className="validator-hint hidden mt-0 empty:py-[0.6rem]">
            {validator.getErrorMessage(name)}
          </div>
        )}
      </div>
    )}
  />
)